import { collection, getDocs, query } from "firebase/firestore";
import { db } from "shared/api/firebase";
import {
  Article,
  ArticleBrandId,
  ArticleCategory,
  ArticleGroupIds,
} from "../types";

export const getArticlesGroupList = async (
  brandId: ArticleBrandId,
  categoryId: ArticleCategory,
  groupId: ArticleGroupIds,
): Promise<Article[]> => {
  const articlesRef = collection(
    db,
    "legalDocuments",
    brandId,
    categoryId,
    groupId,
    "documents",
  );

  const q = query(articlesRef);
  const articlesSnapshot = await getDocs(q);

  return articlesSnapshot.docs.map((doc) => doc.data()) as Article[];
};
